'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = require('./Switch');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Switch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Switch/index.js
// module id = 5614
// module chunks = 39